// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var AuthSession = require("../../../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationPageSelectedConversationMatches_conversation_graphql = require("../../../__generated__/ConversationPageSelectedConversationMatches_conversation_graphql.bs.js");
var ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql = require("../../../__generated__/ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.bs.js");
var ConversationPageSelectedConversationMatchesRenterMatches_match_graphql = require("../../../__generated__/ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.bs.js");
var ConversationPageSelectedConversationMatchesSellerMatches_match_graphql = require("../../../__generated__/ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.bs.js");
var ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql = require("../../../__generated__/ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.bs.js");

var convertFragment = ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationMatchesBuyerMatches_match_graphql.node, convertFragment, fRef);
}

var MatchFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageSelectedConversationMatches$BuyerMatches(props) {
  var matches = use(props.matches);
  return Core__Array.keepSome(matches).map(function (match) {
              var match$1 = match.source.client;
              var clientId = match$1.id;
              var match$2 = match.source.priceRange;
              return JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(ButtonsV5.Link.make, {
                                  href: "/my_clients/" + clientId,
                                  children: Caml_option.some(match$1.displayName)
                                }),
                            ", ",
                            JsxRuntime.jsx("div", {
                                  children: match$2.minPrice.formatted + " - " + match$2.maxPrice.formatted,
                                  className: "text-tan-gold"
                                })
                          ],
                          className: "flex flex-row space-x-1 flex-wrap"
                        }, clientId);
            });
}

var BuyerMatches = {
  MatchFragment: MatchFragment,
  make: ConversationPageSelectedConversationMatches$BuyerMatches
};

var convertFragment$1 = ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationMatchesRenterMatches_match_graphql.node, convertFragment$1, fRef);
}

var MatchFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ConversationPageSelectedConversationMatches$RenterMatches(props) {
  var matches = use$1(props.matches);
  return Core__Array.keepSome(matches).map(function (match) {
              var match$1 = match.source.client;
              var clientId = match$1.id;
              var match$2 = match.source.priceRange;
              return JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(ButtonsV5.Link.make, {
                                  href: "/my_clients/" + clientId,
                                  children: Caml_option.some(match$1.displayName)
                                }),
                            ", ",
                            JsxRuntime.jsx("div", {
                                  children: match$2.minPrice.formatted + " - " + match$2.maxPrice.formatted + "/month",
                                  className: "text-tan-gold"
                                })
                          ],
                          className: "flex flex-row space-x-1 flex-wrap"
                        }, clientId);
            });
}

var RenterMatches = {
  MatchFragment: MatchFragment$1,
  make: ConversationPageSelectedConversationMatches$RenterMatches
};

var convertFragment$2 = ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationMatchesSellerMatches_match_graphql.node, convertFragment$2, fRef);
}

var MatchFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function ConversationPageSelectedConversationMatches$SellerMatchers(props) {
  var matches = use$2(props.matches);
  return Core__Array.keepSome(matches).map(function (match) {
              var match$1 = match.source.client;
              var clientId = match$1.id;
              var match$2 = match.source.propertyLocation;
              var tmp;
              if (match$2 !== undefined) {
                switch (match$2.__typename) {
                  case "PropertyLocationWithHiddenAddress" :
                      tmp = match$2.locationDisplay;
                      break;
                  case "PropertyLocationWithVisibleAddress" :
                      tmp = match$2.locationDisplay;
                      break;
                  case "__unselected" :
                      tmp = undefined;
                      break;
                  
                }
              } else {
                tmp = undefined;
              }
              var match$3 = match.source.price;
              var tmp$1;
              tmp$1 = match$3.__typename === "ExactPrice" ? JsxRuntime.jsx("div", {
                      children: match$3.price.formatted,
                      className: "text-tan-gold"
                    }) : null;
              return JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(ButtonsV5.Link.make, {
                                  href: "/my_clients/" + clientId,
                                  children: Caml_option.some(match$1.displayName)
                                }),
                            ", ",
                            " " + Core__Option.getOr(tmp, ""),
                            tmp$1
                          ],
                          className: "flex flex-row space-x-1 flex-wrap"
                        }, clientId);
            });
}

var SellerMatchers = {
  MatchFragment: MatchFragment$2,
  make: ConversationPageSelectedConversationMatches$SellerMatchers
};

var convertFragment$3 = ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationMatchesRentalOwnerMatches_match_graphql.node, convertFragment$3, fRef);
}

var MatchFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function ConversationPageSelectedConversationMatches$RentalOwnerMatches(props) {
  var matches = use$3(props.matches);
  return Core__Array.filterMap(Core__Array.keepSome(matches), (function (match) {
                var clientId = match.source.client.id;
                var name = match.source.client.displayName;
                var match$1 = match.source.propertyLocation;
                var tmp;
                if (match$1 !== undefined) {
                  switch (match$1.__typename) {
                    case "PropertyLocationWithHiddenAddress" :
                    case "PropertyLocationWithVisibleAddress" :
                        tmp = match$1.locationDisplay;
                        break;
                    case "__unselected" :
                        tmp = undefined;
                        break;
                    
                  }
                } else {
                  tmp = undefined;
                }
                var match$2 = match.source.price;
                var tmp$1;
                tmp$1 = match$2.__typename === "ExactPrice" ? JsxRuntime.jsx("div", {
                        children: match$2.price.formatted + "/month",
                        className: "text-tan-gold"
                      }) : null;
                return Caml_option.some(JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(ButtonsV5.Link.make, {
                                        href: "/my_clients/" + clientId,
                                        children: Caml_option.some(name)
                                      }),
                                  ", ",
                                  " " + Core__Option.getOr(tmp, ""),
                                  tmp$1
                                ],
                                className: "flex flex-row space-x-1 flex-wrap"
                              }, clientId));
              }));
}

var RentalOwnerMatches = {
  MatchFragment: MatchFragment$3,
  make: ConversationPageSelectedConversationMatches$RentalOwnerMatches
};

var convertFragment$4 = ConversationPageSelectedConversationMatches_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationMatches_conversation_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationMatches_conversation_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationMatches_conversation_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationMatches_conversation_graphql.node, convertFragment$4, fRef);
}

var ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function ConversationPageSelectedConversationMatches(props) {
  var conversationContext = use$4(props.conversationContext);
  var ownerAgentId;
  switch (conversationContext.__typename) {
    case "AvailableConversationContext" :
        var conversationContext$1 = conversationContext.context;
        if (conversationContext$1 !== undefined) {
          switch (conversationContext$1.__typename) {
            case "ForSalePropertyV5" :
                var match = conversationContext$1.agentV2;
                if (match !== undefined && match.__typename === "VisibleForSalePropertyAgent") {
                  var match$1 = match.agent;
                  ownerAgentId = match$1 !== undefined ? match$1.id : undefined;
                } else {
                  ownerAgentId = undefined;
                }
                break;
            case "__unselected" :
                ownerAgentId = undefined;
                break;
            default:
              var match$2 = conversationContext$1.agent;
              ownerAgentId = match$2 !== undefined ? match$2.id : undefined;
          }
        } else {
          ownerAgentId = undefined;
        }
        break;
    case "RemovedConversationContext" :
        var match$3 = conversationContext.agent;
        ownerAgentId = match$3 !== undefined ? match$3.id : undefined;
        break;
    case "__unselected" :
        ownerAgentId = undefined;
        break;
    
  }
  var agentIsOwner = AuthSession.useAgentIsCurrentUser(ownerAgentId);
  if (agentIsOwner) {
    return null;
  }
  switch (conversationContext.__typename) {
    case "AvailableConversationContext" :
        var conversationContext$2 = conversationContext.context;
        if (conversationContext$2 === undefined) {
          return null;
        }
        var title;
        switch (conversationContext$2.__typename) {
          case "BuyerNeedV5" :
              var match$4 = conversationContext$2.currentUsersMatches;
              if (match$4 !== undefined) {
                var totalCount = match$4.totalCount;
                title = totalCount !== 0 ? (
                    totalCount !== 1 ? "Your matching active sellers:" : "Your matching active seller:"
                  ) : "You have no matching active sellers";
              } else {
                title = "There was a problem loading matches";
              }
              break;
          case "ForSalePropertyV5" :
              var match$5 = conversationContext$2.currentUsersMatches;
              if (match$5 !== undefined) {
                var totalCount$1 = match$5.totalCount;
                title = totalCount$1 !== 0 ? (
                    totalCount$1 !== 1 ? "Your matching active buyers:" : "Your matching active buyer:"
                  ) : "You have no matching active buyers";
              } else {
                title = "There was a problem loading matches";
              }
              break;
          case "RentalNeedV5" :
              var match$6 = conversationContext$2.currentUsersMatches;
              if (match$6 !== undefined) {
                var totalCount$2 = match$6.totalCount;
                title = totalCount$2 !== 0 ? (
                    totalCount$2 !== 1 ? "Your matching active rental owners:" : "Your matching active rental owner:"
                  ) : "You have no matching active rental owners";
              } else {
                title = "There was a problem loading matches";
              }
              break;
          case "RentalPropertyV5" :
              var match$7 = conversationContext$2.currentUsersMatches;
              if (match$7 !== undefined) {
                var totalCount$3 = match$7.totalCount;
                title = totalCount$3 !== 0 ? (
                    totalCount$3 !== 1 ? "Your matching active renters:" : "Your matching active renter:"
                  ) : "You have no matching active renters";
              } else {
                title = "There was a problem loading matches";
              }
              break;
          case "__unselected" :
              title = undefined;
              break;
          
        }
        if (title === undefined) {
          return null;
        }
        var tmp;
        switch (conversationContext$2.__typename) {
          case "BuyerNeedV5" :
              var match$8 = conversationContext$2.currentUsersMatches;
              tmp = match$8 !== undefined ? JsxRuntime.jsx(ConversationPageSelectedConversationMatches$SellerMatchers, {
                      matches: Core__Array.keepSome(Core__Option.getOr(match$8.edges, [])).map(function (e) {
                            return e.node.fragmentRefs;
                          })
                    }) : null;
              break;
          case "ForSalePropertyV5" :
              var match$9 = conversationContext$2.currentUsersMatches;
              tmp = match$9 !== undefined ? JsxRuntime.jsx(ConversationPageSelectedConversationMatches$BuyerMatches, {
                      matches: Core__Array.keepSome(Core__Option.getOr(match$9.edges, [])).map(function (e) {
                            return e.node.fragmentRefs;
                          })
                    }) : null;
              break;
          case "RentalNeedV5" :
              var match$10 = conversationContext$2.currentUsersMatches;
              tmp = match$10 !== undefined ? JsxRuntime.jsx(ConversationPageSelectedConversationMatches$RentalOwnerMatches, {
                      matches: Core__Array.keepSome(Core__Option.getOr(match$10.edges, [])).map(function (e) {
                            return e.node.fragmentRefs;
                          })
                    }) : null;
              break;
          case "RentalPropertyV5" :
              var match$11 = conversationContext$2.currentUsersMatches;
              tmp = match$11 !== undefined ? JsxRuntime.jsx(ConversationPageSelectedConversationMatches$RenterMatches, {
                      matches: Core__Array.keepSome(Core__Option.getOr(match$11.edges, [])).map(function (e) {
                            return e.node.fragmentRefs;
                          })
                    }) : null;
              break;
          case "__unselected" :
              tmp = null;
              break;
          
        }
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Icon__Jsx3.make, {
                                          icon: "Lock",
                                          className: "mr-1"
                                        }),
                                    "Only visible to you:"
                                  ],
                                  className: "flex flex-row space-x-2 text-gray-600"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: title,
                                  className: "font-bold"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: tmp,
                                  className: "flex flex-col gap-2"
                                })
                          ],
                          className: "border rounded-md p-4 flex flex-col space-y-4"
                        }),
                    className: "mt-6"
                  });
    case "RemovedConversationContext" :
    case "__unselected" :
        return null;
    
  }
}

var make = ConversationPageSelectedConversationMatches;

exports.BuyerMatches = BuyerMatches;
exports.RenterMatches = RenterMatches;
exports.SellerMatchers = SellerMatchers;
exports.RentalOwnerMatches = RentalOwnerMatches;
exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* ButtonsV5 Not a pure module */
